import some from 'lodash/some';

import type { AppData } from '../../types/app_data';
import type { Step } from '../types/step';
import { ChannelTypes } from '../../utils/channel/const';

export const ServiceSplitStep: Step = {
  // Ask which service user is interested in
  id: 'askSelectService',
  pathname: '/servicesplit',
  excludeFromProgressCalculation: true,
  canShow: (appData: AppData) => {
    // If there is 'service=xx' from query string, directly go to specific service flow
    if (appData.specifiedService) {
      return false;
    }
    // Only direct channel will see the service split page
    if (appData.channel !== ChannelTypes.direct && !appData.showServiceSplit) {
      return false;
    }
    // Skip this screen during the traffic school flow
    if (appData.signupParams?.trafficSchoolStatus) {
      return false;
    }
    return !appData.isOnboardingLite;
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => {
    if (!appData.selectedService) {
      return false;
    }
    return some(appData.selectedService, (value) => !!value);
  },
};
